<script>
  import LeadMagnetForm from "../lib/LeadMagnetForm.svelte";
  import { Country } from "./countries";

  export let country = Country.UnitedStates;

  const key = process.env.RECAPTCHA_KEY;
  const url = process.env.CLOUDFLARE_URL;

  const gif = {
    [Country.UnitedStates]: "https://uploads-ssl.webflow.com/614c99cf4f23708b27a37503/632887b4b5508c057f54d452_us_tax_guide.gif"
  }[country];
</script>

<div class="bg-gray-100 flex p-8 gap-x-8">
  <div class="flex-shrink-0 hidden sm:block">
    <img src={gif} alt="Tax Guide" class="w-40 object-scale-down" />
  </div>
  <LeadMagnetForm
    {key}
    {url}
    title="Crypto Tax-Savings Secrets 👀"
    description="Download the FREE guide that’s helped our customers save more than $50 million in crypto taxes."
    submitButtonText="Send Me The Guide"
  />
</div>

<svelte:head>
  <script
    src="https://www.google.com/recaptcha/api.js?render={key}"
    async
    defer></script>
</svelte:head>
